/* eslint-disable ember/no-classic-components, ember/no-component-lifecycle-hooks, ember/no-runloop, ember/require-tagless-components */
import Component from '@ember/component';
import { bind } from '@ember/runloop';

/* global Hammer */

export default class HammerWrapper extends Component {
  enable = false;
  prev() {}
  next() {}

  _setupHammer() {
    // Enable swipe-based gallery navigation
    let hammer = new Hammer.Manager(this.element, {
      dragLockToAxis: true,
      dragBlockHorizontal: true,
      recognizers: [
        [
          Hammer.Swipe,
          { direction: Hammer.DIRECTION_HORIZONTAL, threshold: 10 },
        ],
      ],
    });
    hammer.on('swiperight', bind(this, this.prev));
    hammer.on('swipeleft', bind(this, this.next));
    this._hammer = hammer;
  }

  didInsertElement() {
    super.didInsertElement(...arguments);
    if (this.enable) {
      this._setupHammer();
    }
  }
}
